import type { ChartTzMode } from '../chart/displayOptions';

export function loadTradesTimeMode(): ChartTzMode {
  try {
    const raw = localStorage.getItem('tt_trades_time_mode');
    if (raw === 'local' || raw === 'market' || raw === 'utc') return raw;
  } catch {}
  return 'local';
}

export function saveTradesTimeMode(mode: ChartTzMode) {
  try { localStorage.setItem('tt_trades_time_mode', mode); } catch {}
}
